<template>
  <div data-testid="list-benchmark-page" class="page list-benchmark-page">
    <v-container fluid>
      <v-layout class="mt-4 pa-0">
        <div style="align-self: center">
          <h2 class="section-title">
            <span>ALL Benchmarks</span>
          </h2>
        </div>
        <v-layout align-end class="py-2 justify-end">
          <v-btn @click="$router.push({ name: 'dashboard.benchmark.add' })">
            <span>Add New Benchmark</span>
          </v-btn>
        </v-layout>
      </v-layout>
      <v-card v-if="benchmarks" class="mt-4">
        <AppTable
          :table-data="tableData"
          v-if="benchmarks && benchmarks.length"
          v-on:viewItemClick="(e) => getBenchmarkDetails(e)"
          :disablePagination="true"
        />
      </v-card>
      <div v-if="!benchmarks" class="d-flex align-center justify-center pt-5 mt-5">
        <v-progress-circular indeterminate color="grey" />
      </div>
    </v-container>
    <v-dialog v-model="showCurrentBenchmark" width="50%">
      <v-card v-if="currentBenchmark.id" class="pa-2">
        <v-card-title> {{ currentBenchmark.id }} : {{ currentBenchmark.name }}<br /> </v-card-title>
        <v-card-text>
          <div v-for="(value, prop) in currentBenchmark" v-bind:key="prop">{{ prop }} : {{ value }}</div>
        </v-card-text>
      </v-card>
      <v-card v-else> LOADING... </v-card>
    </v-dialog>
    <AppLoader v-if="fetchingBenchmarks" />
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Watch } from 'vue-property-decorator';
import { Options } from 'vue-class-component';
import AppTable from '@/components/AppTable.vue';
import { Table, DataTableHeader, TableRow, TableColumnType } from '@/types';
import Fund from '@/models/Fund';
import { HTTPServiceClient } from '@/packages/http/service';
import { FETCH_BENCHMARKS, FETCH_BENCHMARK } from '@/modules/benchmarks/store/actionTypes';
import { SET_NAV_HEADER } from '@/store/actionTypes';
import AppLoader from '@/components/AppLoder.vue';

@Options({
  components: {
    AppTable,
    AppLoader,
  },
})
export default class BenchmarkList extends Vue {
  public pagination = {
    page: 1,
    limit: 15,
  };

  public showCurrentBenchmark = false;
  public fetchingBenchmarks = false;

  created() {
    this.bootstrap();
  }

  public bootstrap() {
    this.$store.dispatch(SET_NAV_HEADER, { title: 'Benchmark', tooltip: 'All benchmarks' });
    this.fetchBenchmarks(this.pagination);
  }

  get benchmarks() {
    return this.$store.getters.benchmarks;
  }

  get currentBenchmark() {
    return this.$store.getters.currentBenchmark;
  }

  public get tableData(): Table {
    const columns: DataTableHeader[] = [
      {
        value: 'id',
        title: 'ID',
        type: TableColumnType.STRING,
        align: 'center',
      },
      {
        value: 'name',
        title: 'Name',
        type: TableColumnType.STRING,
        align: 'center',
      },
      {
        value: 'startDate',
        title: 'Name',
        type: TableColumnType.STRING,
        align: 'center',
      },
      {
        value: 'endDate',
        title: 'Name',
        type: TableColumnType.STRING,
        align: 'center',
      },
      {
        value: 'view',
        title: 'View Details',
        type: TableColumnType.ACTIONS,
        align: 'center',
      },
    ];
    return {
      columns,
      rows: this.rows,
    };
  }

  public get rows(): TableRow[] {
    return (
      this.benchmarks &&
      this.benchmarks.map((benchmark: any, it: number) => {
        return {
          id: benchmark.id,
          name: benchmark.name,
          endDate: benchmark.endDate,
          startDate: benchmark.startDate,
        };
      })
    );
  }

  public fetchBenchmarks(data: any = {}) {
    this.$store.dispatch(FETCH_BENCHMARKS, data);
  }
  public async getBenchmarkDetails(id: String) {
    this.fetchingBenchmarks = true;
    await this.$store.dispatch(FETCH_BENCHMARK, id);
    this.showCurrentBenchmark = true;
    this.fetchingBenchmarks = false;
  }
}
</script>
